import {
  PageWrapper,
  RECENTLY_APPROVED_INTAKE_DASHBOARD_PARAMS,
} from "@/components";
import DashboardTableFullView from "@/components/Dashboard/DashboardTableFullView";
import { recentlyApprovedIntakeFieldNames } from "@/enums";
import { routes } from "@/helpers";
import { useColumnFactory } from "@/hooks";
import { useGetRecentlyApprovedIntakesQuery } from "@/services/dashboard";
import { useIntl } from "react-intl";
import { useQueryParams } from "use-query-params";

const PAGINATION_PAGE_SIZE = 10;

const RecentlyApprovedIntakeFullView = () => {
  const intl = useIntl();

  const [queryParams, setQueryParams] = useQueryParams({
    ...RECENTLY_APPROVED_INTAKE_DASHBOARD_PARAMS,
  });

  const {
    createIntakeViewLinkColumn,
    createCustomSortableSmallerNumColumn,
    createFilterableSortableDropdownColumn,
    createFilterableSortableNumberColumn,
    createFilterableCustomSortableNameColumn,
    createFilterableBooleanDropdownColumn,
    createFilterableSortableSmallerNameColumn,
    createSortableDateColumn,
    handleChange,
  } = useColumnFactory(queryParams, setQueryParams);

  const {
    data: { data: projectRecentlyApprovedIntakes, totalCount } = {},
    isFetching,
  } = useGetRecentlyApprovedIntakesQuery({
    ...queryParams,
    pageSize: PAGINATION_PAGE_SIZE,
  });

  return (
    <PageWrapper
      pageTitle={intl.formatMessage({
        id: "dashboard.titles.recentlyApprovedIntake",
      })}
    >
      <DashboardTableFullView
        data={projectRecentlyApprovedIntakes}
        isFetching={isFetching}
        title={intl.formatMessage({
          id: "dashboard.titles.recentlyApprovedIntake",
        })}
        titleRoute={routes.dashboardFullViews.recentlyApprovedIntake}
        totalCount={totalCount}
        columns={[
          createIntakeViewLinkColumn(
            intl.formatMessage({ id: "dashboard.columns.intake" }),
            intl.formatMessage({ id: "dashboard.columns.view" })
          ),
          createFilterableSortableNumberColumn(
            intl.formatMessage({ id: "dashboard.columns.projectNumber" }),
            recentlyApprovedIntakeFieldNames.projectNumber
          ),
          createFilterableCustomSortableNameColumn(
            intl.formatMessage({ id: "dashboard.columns.projectName" }),
            recentlyApprovedIntakeFieldNames.projectName,
            recentlyApprovedIntakeFieldNames.projectNameNormalized
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({ id: "dashboard.columns.projectType" }),
            recentlyApprovedIntakeFieldNames.projectType,
            recentlyApprovedIntakeFieldNames.projectTypeLabel
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({ id: "dashboard.columns.productLine0" }),
            recentlyApprovedIntakeFieldNames.productLine0,
            recentlyApprovedIntakeFieldNames.productLineLabel0
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({ id: "dashboard.columns.productLine1" }),
            recentlyApprovedIntakeFieldNames.productLine1,
            recentlyApprovedIntakeFieldNames.productLineLabel1
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({ id: "dashboard.columns.productLine2" }),
            recentlyApprovedIntakeFieldNames.productLine2,
            recentlyApprovedIntakeFieldNames.productLineLabel2
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({ id: "dashboard.columns.productCategory" }),
            recentlyApprovedIntakeFieldNames.productCategory,
            recentlyApprovedIntakeFieldNames.productCategoryLabel
          ),
          createFilterableSortableDropdownColumn(
            intl.formatMessage({
              id: "dashboard.columns.financeApprovalGroup",
            }),
            recentlyApprovedIntakeFieldNames.financeApprovalGroup,
            recentlyApprovedIntakeFieldNames.financeApprovalGroupLabel
          ),
          createFilterableBooleanDropdownColumn(
            intl.formatMessage({
              id: "dashboard.columns.intangibleAccountingStandard",
            }),
            recentlyApprovedIntakeFieldNames.intangibleAccountingStandard
          ),
          createFilterableBooleanDropdownColumn(
            intl.formatMessage({
              id: "dashboard.columns.platformProject",
            }),
            recentlyApprovedIntakeFieldNames.platformProject
          ),
          createFilterableSortableSmallerNameColumn(
            intl.formatMessage({ id: "dashboard.columns.approverRole" }),
            recentlyApprovedIntakeFieldNames.approverName
          ),
          createFilterableSortableSmallerNameColumn(
            intl.formatMessage({ id: "dashboard.columns.approverName" }),
            recentlyApprovedIntakeFieldNames.approverUserName
          ),
          createSortableDateColumn(
            intl.formatMessage({ id: "dashboard.columns.dateApproved" }),
            recentlyApprovedIntakeFieldNames.dateApproved
          ),
          createCustomSortableSmallerNumColumn(
            intl.formatMessage({ id: "dashboard.columns.days" }),
            recentlyApprovedIntakeFieldNames.daysAvailable,
            recentlyApprovedIntakeFieldNames.dateApproved
          ),
          createFilterableSortableSmallerNameColumn(
            intl.formatMessage({ id: "dashboard.columns.department" }),
            recentlyApprovedIntakeFieldNames.department
          ),
        ]}
        queryParams={queryParams}
        setQueryParams={setQueryParams}
        handleChange={handleChange}
        pageSize={PAGINATION_PAGE_SIZE}
      />
    </PageWrapper>
  );
};

export default RecentlyApprovedIntakeFullView;
